import React from 'react';
import { bonuses } from '../data/bonuses';
import { TopoLines } from './TopoLines';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="topo-dark w-full bg-forest-deep" data-id="element-21" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-22" data-mp="aujz88jhw32f">
        <div className="text-center" data-id="element-23" data-mp="ftmr0ragscsg">
          <p className="eyebrow text-ember" data-id="element-24" data-mp="fsliatgx82dw">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-paper sm:text-5xl" data-id="element-25" data-mp="1tbzdm1byu68">
            Five instant-use <span className="text-ember" data-id="element-26" data-mp="3o2eo3y7vil48">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-paper/80" data-id="element-27" data-mp="3t0ok2b1f9pqw">
            The volumes give you the year. These five clear the usual blockers
            — picking, supplies, badges, risk forms, motivation — so you can
            use it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-28" data-mp="1r78qb5a1furp">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-forest-line bg-forest ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-29" data-mp="3icbxs5a1idsn" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} loading="lazy" className="aspect-square w-full border-b border-forest-line object-cover" data-id="element-30" data-mp="2zglu8dmgl9cn" /> :
          // Portada de respaldo con la identidad del producto
          <div className="topo-light relative flex aspect-[4/3] w-full flex-col justify-between overflow-hidden border-b border-forest-line bg-paper p-5" data-id="element-31" data-mp="33ja3gmf34ia5">
                  <TopoLines className="pointer-events-none absolute -right-8 -bottom-10 h-40 w-40 text-bark/15" data-id="element-32" data-mp="ipwvvcgrge3s" />
                  <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full font-display text-xl text-white ring-4 ring-paper ${bonus.accent}`} data-id="element-33" data-mp="3ciekt08n1oxi">
                    {bonus.number}
                  </span>
                  <div className="relative" data-id="element-34" data-mp="3qixra2xggmxk">
                    <span className="text-[10px] font-bold uppercase tracking-[2px] text-bark" data-id="element-35" data-mp="3qhwdhqp21mc5">
                      Troop Night Ready · Bonus {bonus.number}
                    </span>
                    <p className="mt-1 font-display text-2xl leading-tight text-pine" data-id="element-36" data-mp="2xujqjfezfcib">
                      {bonus.title}
                    </p>
                  </div>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-37" data-mp="37l4nyzix6azn">
                <div className="flex flex-wrap items-center gap-2" data-id="element-38" data-mp="2a4z7yxmqqh9k">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-paper/65" data-id="element-39" data-mp="2a2leuubmff4n">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-ember px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-pine" data-id="element-40" data-mp="27ioofaqv83cw">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-lg leading-snug text-paper" data-id="element-41" data-mp="1xkiouzsj79b7">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-paper/75" data-id="element-42" data-mp="1tmkyvuqxsj6r">
                  {bonus.body}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}